export default __webpack_public_path__ + "static/media/verification1.77f0217f.png";